import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface ErrorStateProps {
  error: unknown
  onRetry?: () => void
  message?: string
  className?: string
}

export function ErrorState({
  error,
  onRetry,
  message = 'Something went wrong',
  className,
}: ErrorStateProps) {
  const errorMessage = error instanceof Error ? error.message : String(error)

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center space-y-4 py-12',
        className
      )}
    >
      <div className="text-6xl">⚠️</div>
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground">{message}</h3>
        <p className="mt-2 text-sm text-muted-foreground">{errorMessage}</p>
      </div>
      {onRetry && (
        <Button onClick={onRetry} variant="outline">
          Try Again
        </Button>
      )}
    </div>
  )
}
